import React from 'react';
import "./Home.css";
import { Link } from "react-router-dom";
import AppsIcon from '@material-ui/icons/Apps';
import { Avatar, IconButton } from '@material-ui/core';
import Search from "../components/Search";
import Footer from "../components/Footer";

function Home() {
    return (
        <div className="home">

            {/* <h1>Home Page</h1> */}

            <div className="home__header">

                <div className="home__headerLeft">
                    <a href='https://facebook.com/arefat.hyeredin'>About</a>
                    <a href='mailto:arefat.hyeredin@gmail.com'>Contact</a>
                    <a href='https://developers.google.com/custom-search/v1/using_rest'>API</a>
                </div>

                <div className="home__headerRight">
                    <Link to='/gmail'>Gmail</Link>
                    <Link to='/images'>Images</Link>
                    <IconButton>
                        <AppsIcon className="home__headerRightappIcon" />
                    </IconButton>
                    <Avatar src="https://cdn3.iconfinder.com/data/icons/generic-avatars/128/avatar_portrait_man_male-128.png" />
                </div>

            </div>

            <div className="home__body">

                <img src="https://fontmeme.com/permalink/201011/d2bd0a10549d22272b4db462403f19b7.png"
                    alt="custom-logo" />

                <div className="home__inputContainer">
                    <Search />
                </div>

            </div>

            <Footer />

        </div>
    )
}

export default Home
